import { SearchableMultiSelect } from '@components/ui/searchable-multi-select';
import { FolderKanban } from 'lucide-react';
import React from 'react';

import type { SelectOption } from '@/types/formSchema';

interface FilterBarProps {
  selectedPrograms: string[];
  onProgramsChange: (programIds: string[]) => void;
  /** Pre-built options so callers can map `value: programId` and `label: programName`. */
  programOptions: SelectOption[];
}

export function FilterBar({ selectedPrograms, onProgramsChange, programOptions }: FilterBarProps) {
  return (
    <SearchableMultiSelect
      selected={selectedPrograms}
      onChange={onProgramsChange}
      options={programOptions.map(opt => ({ value: String(opt.value), label: opt.label }))}
      placeholder="All programs"
      searchPlaceholder="Search programs..."
      icon={FolderKanban}
      className="w-[220px] px-3"
      showClearAll
    />
  );
}
